import { formatTHB } from './numberFormat';

export const getDiscountPromotionLabel = (discountDetails = []) => {
  const details = Array.isArray(discountDetails) ? discountDetails : [];
  const labels = details
    .map(detail => {
      if (Number(detail.discount_type) === 1) {
        return 'Pro สมาชิกใหม่';
      }
      if (Number(detail.discount_type) === 2) {
        return `โปร ${formatTHB(detail.ball_count || 0)} ฟรี ${formatTHB(detail.ball_free || 0)}`;
      }
      return '';
    })
    .filter(Boolean);

  return labels.join(', ');
};

export const getDiscountGroupText = (order = {}) => {
  const promotionLabel = getDiscountPromotionLabel(order.discount_details);
  const discountText = promotionLabel || (order.is_discount ? `ได้ส่วนลด ${formatTHB(order.total_discount)} บาท` : '');
  const netPriceText = `ราคาสุทธิ: ${formatTHB(order.price_bill_final)} บาท`;

  return discountText || netPriceText;
};
